var _objectSpread = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectSpread2").default;
var _objectWithoutProperties = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectWithoutProperties").default;
var _excluded = ["class", "staticClass", "style", "staticStyle", "attrs"];
require("core-js/modules/es.array.concat.js");
module.exports = {
  functional: true,
  render: function render(_h, _vm) {
    var _c = _vm._c,
      _v = _vm._v,
      data = _vm.data,
      _vm$children = _vm.children,
      children = _vm$children === void 0 ? [] : _vm$children;
    var classNames = data.class,
      staticClass = data.staticClass,
      style = data.style,
      staticStyle = data.staticStyle,
      _data$attrs = data.attrs,
      attrs = _data$attrs === void 0 ? {} : _data$attrs,
      rest = _objectWithoutProperties(data, _excluded);
    return _c('svg', _objectSpread({
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "width": "64",
        "height": "64",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }, attrs)
    }, rest), children.concat([_c('defs', [_c('filter', {
      attrs: {
        "x": "-17.4%",
        "y": "-17.4%",
        "width": "134.8%",
        "height": "134.8%",
        "filterUnits": "objectBoundingBox",
        "id": "b"
      }
    }, [_c('feGaussianBlur', {
      attrs: {
        "stdDeviation": "4",
        "in": "SourceAlpha",
        "result": "shadowBlurInner1"
      }
    }), _c('feOffset', {
      attrs: {
        "dy": "-8",
        "in": "shadowBlurInner1",
        "result": "shadowOffsetInner1"
      }
    }), _c('feComposite', {
      attrs: {
        "in": "shadowOffsetInner1",
        "in2": "SourceAlpha",
        "operator": "arithmetic",
        "k2": "-1",
        "k3": "1",
        "result": "shadowInnerInner1"
      }
    }), _c('feColorMatrix', {
      attrs: {
        "values": "0 0 0 0 1 0 0 0 0 0.643137255 0 0 0 0 0.776470588 0 0 0 0.3 0",
        "in": "shadowInnerInner1"
      }
    })]), _c('circle', {
      attrs: {
        "id": "a",
        "cx": "32",
        "cy": "30",
        "r": "23"
      }
    })]), _c('g', {
      attrs: {
        "fill": "none",
        "fill-rule": "evenodd"
      }
    }, [_c('rect', {
      attrs: {
        "width": "64",
        "height": "64",
        "rx": "6"
      }
    }), _c('use', {
      attrs: {
        "fill-opacity": ".3",
        "fill": "#FFA4C6",
        "xlink:href": "#a"
      }
    }), _c('use', {
      attrs: {
        "fill": "#000",
        "filter": "url(#b)",
        "xlink:href": "#a"
      }
    }), _c('circle', {
      attrs: {
        "stroke-opacity": ".4",
        "stroke": "#FFF",
        "stroke-width": ".588",
        "stroke-linejoin": "square",
        "cx": "32",
        "cy": "30",
        "r": "22.706"
      }
    }), _c('g', {
      attrs: {
        "transform": "translate(21 19)",
        "stroke": "#FFF",
        "stroke-width": "1.4"
      }
    }, [_c('circle', {
      attrs: {
        "cx": "11",
        "cy": "11",
        "r": "9.2"
      }
    }), _c('path', {
      attrs: {
        "stroke-linecap": "round",
        "d": "M6.6 11h8.8M11 6.6v8.8"
      }
    })])])]));
  }
};